<template>
  <div>
     
     <div class="row" v-if="permiso!=3">
          <label class="col-sm-2 col-form-label">Abonos</label>

    <b-button v-b-toggle.collapse-1 variant="primary"><i class="fa fa-usd"/></b-button>
     </div>
    <b-collapse id="collapse-1" class="mt-2">
      <b-card>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Fecha Inicio:</label>
          <i class="fa fa-calendar"></i>
          <datetime
          :disabled="permiso==2"
          v-model="fecha_inicio_saldo"
            type="date"
            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
			zone="America/Cancun"
    value-zone="America/Cancun"
          ></datetime>

          <label class="col-sm-2 col-form-label">Fecha Fin:</label>
          <i class="fa fa-calendar"></i>
          <datetime
          :disabled="permiso==2"
          v-model="fecha_fin_saldo"
            type="date"
            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
			zone="America/Cancun"
    value-zone="America/Cancun"
          ></datetime>
          <button style="margin-left:10px" @click="openSaldos()" class="btn btn-success">Ir</button>
        </div>
       
      </b-card>
    </b-collapse>
<br>
     <div class="row" v-if="permiso!=3">
          <label class="col-sm-2 col-form-label">Ventas</label>
    <b-button v-b-toggle.collapse-2 variant="primary" ><i class="fa fa-money"/>
    </b-button>
     </div>
    <b-collapse id="collapse-2" class="mt-2">
      <b-card>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Fecha Inicio:</label>
          <i class="fa fa-calendar"></i>
          <datetime
          :disabled="permiso==2"
          v-model="fecha_inicio_venta"
            type="date"
            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
			zone="America/Cancun"
    value-zone="America/Cancun"
          ></datetime>

          <label class="col-sm-2 col-form-label">Fecha Fin:</label>
          <i class="fa fa-calendar"></i>
          <datetime
          :disabled="permiso==2"
          v-model="fecha_fin_venta"
            type="date"
            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
			zone="America/Cancun"
    value-zone="America/Cancun"
          ></datetime>
          <button style="margin-left:10px" @click="openVentas()" class="btn btn-success">Ir</button>
        </div>
       
      </b-card>
    </b-collapse>
    
    <br>
      <div class="row">
           <label class="col-sm-2 col-form-label">Deudores</label>
          <button  class="btn btn info"  @click="openDeudores"><i class="fa fa-file-pdf-o"></i></button>
      </div>
      <br>
     <div class="row" v-if="permiso==1">
           <label class="col-sm-2 col-form-label">Inventario</label>
          <button class="btn btn info" @click="openInventario"><i class="fa fa-file-pdf-o"></i></button>
      </div>
       <br>
	   <div class="row" v-if="permiso==1">
           <label class="col-sm-2 col-form-label">Inventario Excel</label>
          <button class="btn btn info" @click="openInventarioExcel"><i class="fa fa-file-excel-o"></i></button>
      </div>
       <br>
     <div class="row" v-if="permiso==1">
           <label class="col-sm-2 col-form-label">Clientes</label>
          <button class="btn btn info" @click="openClientes"><i class="fa fa-file-pdf-o"></i></button>
      </div>
  </div>
</template>
<script>
import { url } from "../main.js";
import { Datetime } from "vue-datetime";
import moment from 'moment-timezone'

export default {
  data() {
    return {
      fecha_inicio_saldo: moment().tz("America/Cancun").format(),
      fecha_fin_saldo: moment().tz("America/Cancun").format(),
      fecha_inicio_venta: moment().tz("America/Cancun").format(),
      fecha_fin_venta: moment().tz("America/Cancun").format(),
       permiso: 0
      
    }
  },
  mounted()
  {
this.permiso = localStorage.getItem("permission");
  },
 components: {
    datetime: Datetime
  },methods:{
    openInventario()
    {
     window.open("http://alex.hotel-arrecife.com/wsalex/reporte_inventario.php", "_blank"); 
    },
	openInventarioExcel()
    {
     window.open("https://alex.hotel-arrecife.com/wsalex/apiProductos.php/download_inventory", "_blank"); 
    },
    openClientes()
    {
        window.open("http://alex.hotel-arrecife.com/wsalex/reporte_clientes.php", "_blank"); 
    },
    openDeudores()
    {
 window.open("http://alex.hotel-arrecife.com/wsalex/reporte_deudores.php", "_blank"); 
    },
    openSaldos()
    {
this.fecha_inicio_saldo=moment(this.fecha_inicio_saldo).tz("America/Cancun").format("YYYY-MM-DD");
this.fecha_fin_saldo=moment(this.fecha_fin_saldo).tz("America/Cancun").format("YYYY-MM-DD");

       window.open("http://alex.hotel-arrecife.com/wsalex/reporte_saldos.php?fecha_inicio="+this.fecha_inicio_saldo+"&fecha_fin="+this.fecha_fin_saldo, "_blank"); 
    },
    openVentas()
    {
    this.fecha_inicio_venta=moment(this.fecha_inicio_venta).tz("America/Cancun").format("YYYY-MM-DD");
this.fecha_fin_venta=moment(this.fecha_fin_venta).tz("America/Cancun").format("YYYY-MM-DD");

       window.open("http://alex.hotel-arrecife.com/wsalex/reporte_ventas.php?fecha_inicio="+this.fecha_inicio_venta+"&fecha_fin="+this.fecha_fin_venta, "_blank"); 

    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/reportes.vue